import React from 'react';
import I18n from 'i18n-js';

import { RCIcon } from '../RCIcon';
import CloseSvg from '../../../design-system/icons/core/close.svg?component';
import { RCTooltip } from '../RCTooltip';

interface IProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>
  'aria-label'?: string;
  tooltipText?: string;
}

export function RCCloseButton(props: IProps) {
  function onClick(event) {
    // This is to prevent the hide function on the feed listing
    // card from opening the listing card in a new window
    event.preventDefault();
    event.stopPropagation();
    props.onClick(event);
  }

  const ariaLabel = props['aria-label'] || I18n.t('commons.closeButton.defaultLabel');

  // Defining this inline is necessary so that refs can be forwarded to the component
  // this is used in RCTooltip
  const button = (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="rc-close-button"
    >
      <RCIcon svgComponent={CloseSvg} />
    </button>
  );

  if (!props.tooltipText) {
    return button;
  }

  return (
    <RCTooltip text={props.tooltipText} type="plain">
      {button}
    </RCTooltip>
  );
}
